
import { supabase } from "@/integrations/supabase/client";
import { EmailTemplate } from "@/types/emailTemplates";

/**
 * Create a new email template
 */
export async function createTemplate(
  template: Omit<EmailTemplate, 'id' | 'created_at' | 'updated_at' | 'version'>
): Promise<EmailTemplate | null> {
  try {
    console.log("Creating new template:", template.name);
    
    // Use any type to bypass TypeScript's type checking
    const { data, error } = await (supabase as any)
      .from('email_templates')
      .insert({
        ...template,
        version: 1,
        is_active: true,
      })
      .select()
      .single();

    if (error) {
      throw new Error(`Error creating template: ${error.message}`);
    }

    return data as EmailTemplate;
  } catch (error: any) {
    console.error("Error in createTemplate:", error);
    throw new Error(`Failed to create email template: ${error.message}`);
  }
}
